import { defineComponent as _defineComponent } from 'vue'
import type { SportType } from '@/@types/graphql-types';

import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import MultiStepEventEncounter from '@/features/sports/components/global/MultiStepEventEncounter.vue';
import Subheading from '@/features/sports/components/ui/Subheading.vue';

import { ObjectType } from '@/@types/graphql-types';
import { SportPageType } from '@/features/sports/types/interfaces';
import { isMultiStepSport } from '@/features/sports/types/enums';

import { SnowplowSportContext } from '@/helpers/tracking/providers';

import { useI18n } from '@/helpers/composables/useI18n';
import { useUpcomingEventsData } from '@/features/sports/composables/useUpcomingEventsData';

import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiStepEventEncounterList',
  props: {
    filterBy: null,
    filterByName: null,
    filterByParam: null,
    sportType: null,
    sportPageType: null
  },
  setup(__props: any) {

const props = __props as {
	filterBy: 'sport' | 'competition';
	// sport name or competition name
	filterByName: string;
	filterByParam: Array<SportType | string>;
	sportType: SportType;
	sportPageType: SportPageType;
};



const { t, tc } = useI18n();
const languageStore = storeToRefs(useLanguageStore());

const { eventTimeGroup, events, isDataLoading } = useUpcomingEventsData({
	sportType: () => props.sportType,
	filterBy: () => props.filterBy,
	filterByParam: () => props.filterByParam,
});

const sportContext = computed(() => {
	const objectType = getObjectTypeFromSportPageType(props.sportPageType);
	const sportType = props.sportType || props.filterByParam; // TODO check why on Event page sportType is undefined
	if (!objectType || !sportType) return [];
	return [new SnowplowSportContext(sportType, objectType)];
});

function getObjectTypeFromSportPageType(pageType: string): ObjectType {
	return pageType == SportPageType.SportOverview ? ObjectType.Sport : (pageType as ObjectType);
}

/**
 * This supports
 *
 * SPORT EVENTS:
 * 	- $t('SPORTS_WEBAPP_HEADER_SPORT_EVENTS_UPCOMING')
 * 	- $t('SPORTS_WEBAPP_HEADER_SPORT_EVENTS_LIVE')
 * 	- $t('SPORTS_WEBAPP_HEADER_SPORT_EVENTS_TODAY')
 *
 * 	COMPETITION EVENTS:
 * 	- $t('SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_UPCOMING')
 * 	- $t('SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_LIVE')
 * 	- $t('SPORTS_WEBAPP_HEADER_COMPETITION_EVENTS_TODAY')
 */
function getSubheading(eventTimeGroup: 'live' | 'today' | 'upcoming') {
	const translatable = `SPORTS_WEBAPP_HEADER_${props.filterBy.toUpperCase()}_EVENTS_${eventTimeGroup.toUpperCase()}`;
	const translationMatches = isMultiStepSport(props.sportType)
		? tc('SPORTS_WEBAPP_RACES')
		: tc('SPORTS_WEBAPP_MATCHES');
	return t(translatable, { event: props.filterByName, type: translationMatches });
}

return { __sfc: true,props, t, tc, languageStore, eventTimeGroup, events, isDataLoading, sportContext, getObjectTypeFromSportPageType, getSubheading, HiddenHorizontalScrollbar, MultiStepEventEncounter, Subheading }
}

})